import { api } from '@/core/helpers/axiosHelper';

export default {
   async get(slot_state_ids: Array<number>) {
      return await api
         .get('/slot-state', {
            ...cacheFirstConfig,
            params: {
               'filter[from_slot_states]': slot_state_ids,
            },
         })
         .then((response) => {
            return response.data;
         });
   },
   // TODO: Replace with type
   async postSlotStateAllowedOrNot(body: Array<any>) {
      return await api.post('/slot-state/allowed-or-not', body).then((response) => response?.data);
   },
   async getPossibleTargets(slot_ids: string) {
      return await api
         .get('/slot-state/possible-target', {
            params: {
               slot_ids,
            },
         })
         .then((response) => response?.data);
   },
};
